import { render, staticRenderFns } from "./LegalPageHeader.vue?vue&type=template&id=0dc136e3"
import script from "./LegalPageHeader.vue?vue&type=script&lang=js"
export * from "./LegalPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports